<template>
  <div class="wrapper"> <v-sheet
      tile
      height="108"
      class="d-flex align-center"
    >
      <v-btn
        icon
        class="ma-2"
        @click="$refs.calendar.prev()"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>

      <v-select
        v-model="type"
        :items="types"
        dense
        outlined
        hide-details
        class="ma-2"
        label="type"
      ></v-select>

      <v-select
        v-model="mode"
        :items="modes"
        dense
        outlined
        hide-details
        label="event-overlap-mode"
        class="ma-2"
      ></v-select>

      <v-select
        v-model="weekday"
        :items="weekdays"
        dense
        outlined
        hide-details
        label="weekdays"
        class="ma-2"
      ></v-select>

      <v-spacer></v-spacer>

      <span class="text-h6 text-no-wrap">{{ $refs.calendar ? $refs.calendar.title : '' }}</span>

      <v-spacer></v-spacer>

      <v-btn
        icon
        class="ma-2"
        @click="$refs.calendar.next()"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-sheet>

    <v-sheet height="600">
      <v-calendar
        ref="calendar"
        v-model="value"
        :weekdays="weekday"
        :type="type"
        :events="events"
        :event-overlap-mode="mode"
        :event-overlap-threshold="30"
        :event-color="getEventColor"
        @change="updateRangeAndFetchEvents"
        @click:event="showEvent"
        @click:date="viewDay"
      ></v-calendar>
    </v-sheet>

    <v-dialog v-model="selectedOpen" :close-on-content-click="false" max-width="450" persistent>
      <v-card v-if="selectedEvent && Object.keys(selectedEvent).length > 0">
        <v-toolbar :color="selectedEvent.color || 'primary'" dark>
          <v-toolbar-title>{{ selectedEvent.name || 'Appointment Details' }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="cancelEventEdit">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-4">
          <p class="subtitle-1">Edit Appointment Date & Time (AEST)</p>
          <v-row>
            <v-col cols="12">
              <v-menu
                ref="dateMenu"
                v-model="dateMenuOpen"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="editableEventDate"
                    label="Edit Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="editableEventDate"
                  no-title
                  @input="dateMenuOpen = false"
                  type="date"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12">
              <v-menu
                ref="timeMenu"
                v-model="timeMenuOpen"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="editableEventTime"
                    label="Edit Time"
                    prepend-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="timeMenuOpen"
                  v-model="editableEventTime"
                  format="ampm"
                  scrollable
                  full-width
                  @click:minute="$refs.timeMenu.save(editableEventTime)"
                ></v-time-picker>
              </v-menu>
            </v-col>
          </v-row>
          <p v-if="selectedEvent.phone_number" class="mt-3">Phone: <strong>{{ selectedEvent.phone_number }}</strong></p>
          <p v-if="selectedEvent.address">Meeting Point: <strong>{{ selectedEvent.address }}</strong></p>
          <p v-if="selectedEvent.notes">Notes: <strong>{{ selectedEvent.notes }}</strong></p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelEventEdit">
            Cancel
          </v-btn>
          <v-btn color="primary" @click="saveEventChanges">
            Save Changes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div> 
</template>

<script>
  import { axios } from '../../../utils';

  export default {
    data: () => ({
      type: 'month',
      types: ['month', 'week'],
      mode: 'stack',
      modes: ['stack', 'column'],
      weekday: [0, 1, 2, 3, 4, 5, 6],
      weekdays: [
        { text: 'Sun - Sat', value: [0, 1, 2, 3, 4, 5, 6] },
        { text: 'Mon - Sun', value: [1, 2, 3, 4, 5, 6, 0] },
        { text: 'Mon - Fri', value: [1, 2, 3, 4, 5] },
        { text: 'Mon, Wed, Fri', value: [1, 3, 5] },
      ],
      value: '',

      events: [],
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],

      start: null,
      end: null,

      editableEventDate: null, // For v-date-picker (YYYY-MM-DD)
      editableEventTime: null, // For v-time-picker (HH:MM 24hr)
      dateMenuOpen: false,    // To control v-date-picker menu
      timeMenuOpen: false,
      employeeId: null
    }),
    mounted() {
      this.value = new Date().toISOString().substr(0, 10);
    },
    props: {
    id: {
      type: String,
      required: true
    }
  },
    methods: {
    updateRangeAndFetchEvents ({ start, end }) {
        this.start = start;
        this.end = end;
        this.employeeId =  this.id;   
        this.fetchAppointments();
      },

     async fetchAppointments() {
    const params = {};
    if (this.start && this.start.date) {
        params.start_date = this.start.date;
    }
    if (this.end && this.end.date) {
        params.end_date = this.end.date;
    }
    params.employee_id = this.employeeId;
    console.log(params, 'params set here')
    try {
        const response = await axios.get('/api/admin/appointments-calendar', { params });
        console.log('Raw API response data for fetchAppointments:', response.data.data);

        this.events = response.data.data.map((appointment, index) => {
            const baseUtcTimestampFromApi = appointment.appointments_date; // e.g., "2025-05-28T14:00:00Z"
            const timeSourceTimestampFromApi = appointment.appointments_time; // e.g., "2025-05-21T02:05:00.000000Z"

            if (!baseUtcTimestampFromApi) {
                console.warn(`Skipping appointment ${index} (ID: ${appointment.id || 'N/A'}) due to missing baseUtcTimestampFromApi (appointments_date).`, appointment);
                return null;
            }

            let baseDateObject = null;
            try {
                baseDateObject = new Date(baseUtcTimestampFromApi);
                if (isNaN(baseDateObject.getTime())) {
                    console.error(`Invalid Date object from baseUtcTimestampFromApi: "${baseUtcTimestampFromApi}"`, appointment);
                    return null;
                }
            } catch (e) {
                console.error(`Error creating Date object from baseUtcTimestampFromApi: "${baseUtcTimestampFromApi}"`, e, appointment);
                return null;
            }

            // Get AEST date components from baseDateObject
            const targetAestYear = baseDateObject.getFullYear();
            const targetAestMonth = baseDateObject.getMonth(); // 0-indexed
            const targetAestDay = baseDateObject.getDate();

            // Get UTC time components from timeSourceTimestampFromApi
            let intendedUTCHour = 0;
            let intendedUTCMinute = 0;
            let intendedUTCSecond = 0;

            if (timeSourceTimestampFromApi) {
                let timeSourceDateObject = null;
                try {
                    timeSourceDateObject = new Date(timeSourceTimestampFromApi);
                    if (isNaN(timeSourceDateObject.getTime())) {
                        console.warn(`Invalid Date object from timeSourceTimestampFromApi: "${timeSourceTimestampFromApi}". Using 00:00:00 UTC for time part.`);
                    } else {
                        intendedUTCHour = timeSourceDateObject.getUTCHours();
                        intendedUTCMinute = timeSourceDateObject.getUTCMinutes();
                        intendedUTCSecond = timeSourceDateObject.getUTCSeconds();
                    }
                } catch (e) {
                    console.warn(`Error creating Date object from timeSourceTimestampFromApi: "${timeSourceTimestampFromApi}". Using 00:00:00 UTC for time part.`, e);
                }
            } else {
                console.warn(`appointments_time is null or undefined. Using 00:00:00 UTC for time part.`);
            }

            // Create the final Date object using Date.UTC()
            const finalStartDateTime = new Date(Date.UTC(
                targetAestYear,
                targetAestMonth,
                targetAestDay,
                intendedUTCHour,
                intendedUTCMinute,
                intendedUTCSecond
            ));

            if (isNaN(finalStartDateTime.getTime())) {
                console.error(`Final Date object is invalid for appointment ID ${appointment.id || index}. Check parsed components.`, appointment);
                return null;
            }

            const displayYear = finalStartDateTime.getFullYear();
            const displayMonth = (finalStartDateTime.getMonth() + 1).toString().padStart(2, '0');
            const displayDay = finalStartDateTime.getDate().toString().padStart(2, '0');
            const displayDate = `${displayYear}-${displayMonth}-${displayDay}`;

            const displayHours = finalStartDateTime.getHours().toString().padStart(2, '0');
            const displayMinutes = finalStartDateTime.getMinutes().toString().padStart(2, '0');
            const displayTime = `${displayHours}:${displayMinutes}`;

            return {
                id: appointment.id,
                name: appointment.phone_call ? appointment.phone_call.business_name : 'N/A',
                start: finalStartDateTime,
                end: finalStartDateTime,
                color: this.colors[this.rnd(0, this.colors.length - 1)],
                timed: true,
                date: displayDate,
                time: displayTime,
                phone_call_id: appointment.phone_call_id,
                phone_number: appointment.phone_call ? appointment.phone_call.phone_number : 'N/A',
                notes: appointment.phone_call && appointment.phone_call.notes ? appointment.phone_call.notes : '',
                address: appointment.phone_call ? appointment.phone_call.address :'N/A'
            };
        }).filter(event => event !== null);

    } catch (error) {
        console.error('Error fetching appointments:', error.response?.data || error.message || error);
        this.events = [];
    }
},


showEvent({ nativeEvent, event }) {
  const open = () => {
    // Work on a deep copy of the event for editing, so cancelling doesn't affect the original in the list yet
    this.selectedEvent = JSON.parse(JSON.stringify(event)); 
    
    // Initialize editable fields from the selected event's AEST-formatted date/time
    // These should be in "YYYY-MM-DD" and "HH:MM" (AEST) format from fetchAppointments
    this.editableEventDate = this.selectedEvent.date; 
    this.editableEventTime = this.selectedEvent.time; 

    this.selectedElement = nativeEvent.target; 
    this.$nextTick(() => {
      this.selectedOpen = true;
    });
  };

  if (this.selectedOpen) {
    this.selectedOpen = false;
    this.$nextTick(open);
  } else {
    open();
  }
  nativeEvent.stopPropagation();
},

// Inside methods:
async saveEventChanges() {
  if (!this.selectedEvent || !this.editableEventDate || !this.editableEventTime) {
    console.error('Missing data for saving event changes.');
    // TODO: Show user-friendly error
    return;
  }

  const eventId = this.selectedEvent.id; 
  if (!eventId) {
      console.error('Event ID is missing, cannot update.');
      // TODO: Show user-friendly error
      return;
  }

  // editableEventDate is "YYYY-MM-DD" (AEST)
  // editableEventTime is "HH:MM" (AEST, 24hr format from v-time-picker v-model)
  const payload = {
    appointments_date: this.editableEventDate, // e.g., "2025-05-29"
    appointments_time: this.editableEventTime, // e.g., "13:30"
    // If phone_call_id needs to be sent for update or is part of validated data:
    // phone_call_id: this.selectedEvent.phone_call_id, 
  };

  console.log('Attempting to save changes for event ID:', eventId);
  console.log('Payload to send to API:', payload);

  try {
    const response = await axios.put(`/api/admin/appointments-calendar/${eventId}`, payload);
    console.log('Update successful:', response.data);
    const updatedAppointmentFromApi = response.data.appointment; // The updated appointment from backend

    // Find the original event in the this.events array to update it
    const originalEventIndex = this.events.findIndex(
      e => (e.id || e.phone_call_id) === eventId
    );

    if (originalEventIndex !== -1) {
      // To ensure absolute consistency with the backend's state (including any transformations it did),
      // it's best to re-process the returned appointment data just like in fetchAppointments.

      // Step 1: Create the new JS Date object (start/end) from the API response
      // The backend returns the `appointmentCalendar` object. We need to know its date/time structure.
      // Assuming it returns fields like `appointments_date` (UTC timestamp) and `appointments_time` (UTC time string)
      // or however your backend formats it in the JSON response for an AppointmentCalendar.
      // For this example, let's assume the response `updatedAppointmentFromApi` has the same structure
      // as the items in `WorkspaceAppointments` (i.e., `appointments_date` as a full UTC string,
      // and `appointments_time` as the relevant time string/timestamp).

      const baseUtcTimestamp = updatedAppointmentFromApi.appointments_date;
      const timeSourceTimestamp = updatedAppointmentFromApi.appointments_time;

      let newStartDateTime = null;
      if (baseUtcTimestamp) {
          let tempBaseDate = new Date(baseUtcTimestamp);
          let tempAestYear = tempBaseDate.getFullYear();
          let tempAestMonth = tempBaseDate.getMonth();
          let tempAestDay = tempBaseDate.getDate();
          let tempUTCHour = 0, tempUTCMinute = 0, tempUTCSecond = 0;

          if (timeSourceTimestamp) {
              let tempTimeSource = new Date(timeSourceTimestamp);
              if (!isNaN(tempTimeSource.getTime())) {
                  tempUTCHour = tempTimeSource.getUTCHours();
                  tempUTCMinute = tempTimeSource.getUTCMinutes();
                  tempUTCSecond = tempTimeSource.getUTCSeconds();
              }
          }
          newStartDateTime = new Date(Date.UTC(tempAestYear, tempAestMonth, tempAestDay, tempUTCHour, tempUTCMinute, tempUTCSecond));
      }

      if (newStartDateTime && !isNaN(newStartDateTime.getTime())) {
        const finalDisplayYear = newStartDateTime.getFullYear();
        const finalDisplayMonth = (newStartDateTime.getMonth() + 1).toString().padStart(2, '0');
        const finalDisplayDay = newStartDateTime.getDate().toString().padStart(2, '0');
        const finalDisplayDate = `${finalDisplayYear}-${finalDisplayMonth}-${finalDisplayDay}`;

        const finalDisplayHours = newStartDateTime.getHours().toString().padStart(2, '0');
        const finalDisplayMinutes = newStartDateTime.getMinutes().toString().padStart(2, '0');
        const finalDisplayTime = `${finalDisplayHours}:${finalDisplayMinutes}`;
        
        const eventForCalendar = {
          ...this.events[originalEventIndex], // Keep other properties like name, color, phone_call_id
          id: updatedAppointmentFromApi.id || eventId, // Ensure ID is updated if it changed or came from API
          start: newStartDateTime,
          end: newStartDateTime, // Assuming point-in-time
          date: finalDisplayDate,
          time: finalDisplayTime,
          // Update any other fields that might have changed from response.data.appointment
          notes: updatedAppointmentFromApi.notes || (this.events[originalEventIndex].phone_call ? this.events[originalEventIndex].phone_call.notes : ''), 
        };
         this.$set(this.events, originalEventIndex, eventForCalendar);
      } else {
         console.warn("Failed to process updated event from API, re-fetching all appointments for consistency.");
         this.fetchAppointments(); // Fallback to re-fetching all
      }
    } else {
        console.warn("Original event not found in local list after update. Re-fetching all.");
        this.fetchAppointments(); // Fallback
    }

    this.selectedOpen = false;
    this.editableEventDate = null;
    this.editableEventTime = null;
    alert('Appointment updated successfully!');

  } catch (error) {
    console.error('Error saving event changes via API:', error.response?.data || error.message);
    let errorMessage = 'Failed to update appointment.';
    if (error.response && error.response.data && error.response.data.errors) {
        // Extract Laravel validation errors
        const errors = error.response.data.errors;
        errorMessage += Object.values(errors).map(errArray => errArray.join(', ')).join('; ');
    } else if (error.response && error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message;
    }
    alert(errorMessage);
  }
},
// ... other methods
 cancelEventEdit() { // <<< --- ADD THIS METHOD ---
        this.selectedOpen = false;
        // Reset the editable fields if the user cancels
        this.editableEventDate = null; 
        this.editableEventTime = null;
        // Optionally reset selectedEvent if you don't want to retain its data for any reason
        // this.selectedEvent = {}; 
      },
      getEventColor (event) {
        return event.color;
      },

      rnd (a, b) {
        return Math.floor((b - a + 1) * Math.random()) + a;
      },

      viewDay({ date }) {
        this.value = date;
        this.type = 'day';
      },
    },
  }
</script>

<style scoped>

</style>
